class SlideshowSlick extends HTMLElement {
  constructor() {
    super();

    const setSize = this.setSlickHeight();
    this.initSlideshowSlick();

    window.addEventListener('resize', setSize, false);
  }

  setSlickHeight(){
    const window_width = document.body.clientWidth;

    const announcement_bar = document.querySelector('announcement-bar').getBoundingClientRect().height;
    const header_height = document.querySelector('sticky-header').getBoundingClientRect().height;
    const slideshow_holder = this.querySelector('.slideshow-slick-holder');

  }

  initSlideshowSlick(){
    const slideshow = this.querySelector('.slideshow');

    $(slideshow).slick({
      dots: this.dataset.dots == 'true' ? true : false,
      arrows: this.dataset.arrows == 'true' ? true : false,
      infinite: true,
      slidesToShow: 1,
      autoplay: this.dataset.autoplay == 'true' ? true : false,
      autoplaySpeed: this.dataset.speed
    });
  }
}

customElements.define('slideshow-slick', SlideshowSlick);
